import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  addHtmlRootEventListener,
  appendHtmlElementChild,
  CURRENCY_EURO,
  EASE_IN_TRANSITION_TIME,
  enableHtmlElement,
  getHtmlElement,
  isDefined,
  isPresent,
  obj2string,
  parseAmount,
  parseCategoryName,
  parseEncasing,
  removeHtmlChildren,
  removeHtmlElementClass,
  renderWebComponent,
  sanitize,
  scrollHtmlElementIntoView,
  selectHtmlElement,
  setHtmlElementContent,
  setHtmlElementValue,
  string2obj,
  titleize,
  range
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";
import { SubmissionListBlockModalComponent } from "./SubmissionListBlockModalComponent";


const numeric_values = range(1.5, 10.0, 0.5)


export class SupplementaryItemFormComponent extends HTMLElement {
  props = {};
  showMiddlemanPrices = true
  newSupplementaryItem = {}
  emptyItem = {
    description: '',
    estimated_value: 1,
    brand_id: null,
    category_id: null,
    encasing: null,
    requested_service: null,
    label_language: null,
    label_type: 'radiant',
    grading_lower_limit: null,
    case_lower_limit: null
  }
  pricingParams = {
    category_id: null,
    encasing: null,
  }
  prices = {}

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);

    this.newSupplementaryItem = { ...this.emptyItem }

    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }


  connectedCallback() {
    Object.keys(this.newSupplementaryItem).forEach(key => {
      if (!['brand', 'category'].includes(key)) {
        addHtmlElementEventListener(this.shadowRoot, key, ["description", "estimated_value"].includes(key) ? "input" : "change", (e) => this.setNewSupplementaryItem(key, key === "description" ? e.target.value.trim() : e.target.value, e.target.name));

        addHtmlElementEventListener(this.shadowRoot, `${key}_container`, 'mouseover' , (e) => this.eventBus.publish(`enable-hover-question-tooltip-${key}_container`, true))
        addHtmlElementEventListener(this.shadowRoot, `${key}_container`, 'mouseout' , (e) => this.eventBus.publish(`enable-hover-question-tooltip-${key}_container`, false))
      }
    })
    addHtmlElementEventListener(this.shadowRoot, 'add_new_product_btn', 'click', (e) => this.createNewSupplementaryItem());
    addHtmlElementEventListener(this.shadowRoot, 'refresh', 'click', (e) => this.refreshItem());
    addHtmlRootEventListener(window, 'keydown', (e) => e.key === 'Enter' && getHtmlElement(this.shadowRoot, 'form-container').contains(this.shadowRoot.activeElement) ? this.createNewSupplementaryItem() : {});
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList) );
    this.eventBus.subscribe('changed-grader-company', (graderCompany) => this.handleChangeGraderCompany(graderCompany));

    this.eventBus.subscribe('changed-middleman-price-rendering', (show) => {
      this.showMiddlemanPrices = show;
      this.handleMiddlemanEstimatedPriceRendering();
    });
  }


  // Funzione che controlla se il nuovo prodotto che l'utente vuole aggiungere alla sua submission list abbia tutti i
  // campi obbligatori valorizzati
  isValidProduct(doNotShowError) {
    let outcome = true;
    Object.keys(this.newSupplementaryItem).forEach(key => {
      if (!['case_lower_limit', 'grading_lower_limit'].includes(key) && !isDefined(this.newSupplementaryItem[key])) {
        if (!doNotShowError)
          removeHtmlElementClass(this.shadowRoot, `${key}_alert`, 'd-none');
        outcome = false;
      } else {
        addHtmlElementClass(this.shadowRoot, `${key}_alert`, 'd-none');
      }
    })

    if (!doNotShowError || outcome)
      this.handleRenderingSubbanner('validations_container', !outcome, outcome === false ? () => scrollHtmlElementIntoView(this.shadowRoot, 'validations_container', false) : () => {});

    return outcome;
  }


  // Funzione che si occupa di settare i vari parametri del nuovo supplementary item che l'utente sta aggiungendo
  // alla sua submission list
  setNewSupplementaryItem(key, value, name) {
    if (isDefined(value)) {
      this.newSupplementaryItem[key] = sanitize(value);
      this.isValidProduct(true);
      if (!['description', 'estimated_value'].includes(key))
        selectHtmlElement(this.shadowRoot, `${key}_${this.newSupplementaryItem[key]}`, "selected");
    } else {
      this.newSupplementaryItem[key] = null;
      if (!['description', 'estimated_value'].includes(key))
        selectHtmlElement(this.shadowRoot, `no_${key}`, 'selected');
    }


    if (this.newSupplementaryItem.requested_service === 'grading') {
      removeHtmlElementClass(this.shadowRoot, 'grading_lower_limit', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'grading_lower_limit_not_applicable', 'd-none');

      if (this.newSupplementaryItem.encasing === 'case' && !this.isCardNotGradableOnSleeve(this.newSupplementaryItem.category_id)) {
        removeHtmlElementClass(this.shadowRoot, "case_lower_limit", "d-none");
        addHtmlElementClass(this.shadowRoot, "case_lower_limit_not_applicable", "d-none");
      }
      else {
        this.newSupplementaryItem['case_lower_limit'] = null;
        addHtmlElementClass(this.shadowRoot, 'case_lower_limit', 'd-none');
        removeHtmlElementClass(this.shadowRoot, 'case_lower_limit_not_applicable', 'd-none');
        selectHtmlElement(this.shadowRoot, 'no_case_lower_limit', 'selected');
      }
    }
    else {
      this.newSupplementaryItem['grading_lower_limit'] = null;
      addHtmlElementClass(this.shadowRoot, 'grading_lower_limit', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'grading_lower_limit_not_applicable', 'd-none');
      selectHtmlElement(this.shadowRoot, 'no_grading_lower_limit', 'selected');
      this.newSupplementaryItem['case_lower_limit'] = null;
      addHtmlElementClass(this.shadowRoot, 'case_lower_limit', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'case_lower_limit_not_applicable', 'd-none');
      selectHtmlElement(this.shadowRoot, 'no_case_lower_limit', 'selected');
    }

    if (key === 'category_id') {
      const category = this.props.categories.filter((category) => category[1] == value);
      this.manageEncasingOptionsRendering(category[0])
    } else if (key === 'brand_id') {
      const category = this.props.categories.filter((category) => category[1] == this.newSupplementaryItem.category_id);
      this.manageEncasingOptionsRendering(category[0])
    }

    if (name) {
      if (name && !['description', 'estimated_value'].includes(key))
        this.shadowRoot.querySelector(`select[name=input_field_${Number(name.split('_')[2]) + 1}]`)?.focus();
      // if (name && !['description', 'estimated_value', 'category_id'].includes(key))
      //   this.shadowRoot.querySelector(`select[name=input_field_${Number(name.split('_')[2]) + 1}]`)?.focus();
      // else if (key === 'category_id')
      //   this.shadowRoot.querySelector(`input[name=input_field_${Number(name.split('_')[2]) + 1}]`)?.focus();
    }

    this.getSupplementaryItemEstimatedPrice();
  }


  // Funzione che refresha i dati del prodotto che l'utente sta inserendo in submission list
  refreshItem() {
    Object.keys(this.emptyItem).forEach(key => {
      this.setNewSupplementaryItem(key, this.emptyItem[key]);
      addHtmlElementClass(this.shadowRoot, `${key}_alert`, 'd-none');
    });
    setHtmlElementValue(this.shadowRoot, 'description', '');
    setHtmlElementValue(this.shadowRoot, 'estimated_value', 1);
    setHtmlElementContent(this.shadowRoot, 'estimated_price', '0');
    setHtmlElementContent(this.shadowRoot, 'customer_estimated_price', '0');

    this.handleRenderingSubbanner('validations_container', false);
  }


  // Funzione che si occupa di aggiornare le opzioni di encasing del prodotto che l'utente sta aggiungendo
  // alla sua submission list quando cambia la categoria o il brand di appartenenza del prodotto stesso
  manageEncasingOptionsRendering(newCategory) {
    if (newCategory) {
      const options = document.createElement('template');
      let optionsContent = ``;
      let enableSleeveOption = false;
      let enableCaseOption = false;

      if (this.gradableCategoryOnEncasing('sleeve', newCategory[1]) && !this.isCardNotGradableOnSleeve(newCategory[1]))
        enableSleeveOption = true;
      if (this.gradableCategoryOnEncasing('case', newCategory[1]))
        enableCaseOption = true;

      optionsContent = `
        <option value="" id="no_encasing">
          ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
        </option>`;

      if (enableCaseOption) {
        optionsContent = optionsContent +
          `<option value="case" id="encasing_case">
            ${titleize(parseEncasing("case", newCategory[0]).toLowerCase())}
          </option>`;
      }

      if (enableSleeveOption) {
        optionsContent = optionsContent +
          `<option value="sleeve" id="encasing_sleeve">
            ${titleize(parseEncasing("sleeve", newCategory[0]).toLowerCase())}
          </option>`;
      }

      options.innerHTML = optionsContent;
      removeHtmlChildren(getHtmlElement(this.shadowRoot, 'encasing'))
      appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'encasing'), options.content.cloneNode(true));

      let newEncasing = this.newSupplementaryItem.encasing
      if (this.isCardNotGradableOnSleeve(newCategory[1]))
        newEncasing = 'case'
      else if ((!this.gradableCategoryOnEncasing(this.newSupplementaryItem.encasing, newCategory[1])))
        newEncasing = this.newSupplementaryItem.encasing === 'sleeve' ? 'case' : 'sleeve'
      this.setNewSupplementaryItem('encasing', newEncasing);
    }
  }


  // Funzione che si occupa di aggiornare l'interfaccia grafica del form di immissione di un nuovo prodotto
  // nella submission list quando l'utente sceglie una nuova casa di gradazione a cui mandare i suoi prodotti
  handleChangeGraderCompany(newGraderCompany) {
    this.props.submissionList['grader_company'] = newGraderCompany;

    const options = document.createElement('template');
    let optionsContent = `
      <option value="" id="no_category_id">
        ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
      </option>`;
    let firstCategory = null;
    for (const category of this.props.categories) {
      if (this.gradableCategory(category[1])) {
        optionsContent = optionsContent +
          `<option value=${category[1]} id="category_id_${category[1]}">
             ${parseCategoryName(category[0])}
          </option>`;

        if (!firstCategory)
          firstCategory = category;
      }
    }

    options.innerHTML = optionsContent;
    removeHtmlChildren(getHtmlElement(this.shadowRoot, 'category_id'))
    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'category_id'), options.content.cloneNode(true));

    if (!this.gradableCategory(this.newSupplementaryItem.category_id))
      this.setNewSupplementaryItem("category_id", null);
    else
      this.setNewSupplementaryItem("category_id", this.newSupplementaryItem.category_id);
  }


  // Metodo che verifica se una certa categoria sia gradabile dalla casa di gradazione corrente (cioè quella scelta
  // dall'utente fino ad ora tra quelle possibili a cui mandare a gradare i prodotti)
  gradableCategory(categoryId) {
    return categoryId && this.props.submissionList.grader_company.gradable_categories.includes(Number(categoryId));
  }


  // Metodo che verifica se una certa categoria sia gradabile all'interno di un certo involucro dalla casa di
  // gradazione corrente (cioè quella scelta dall'utente fino ad ora tra quelle possibili a cui mandare a gradare i
  // prodotti)
  gradableCategoryOnEncasing(encasing, categoryId) {
    if (encasing)
      return categoryId && this.props.submissionList.grader_company[`gradable_categories_on_${encasing}`].includes(Number(categoryId));
    else
      return true;
  }


  // Funzione che verifica se il nuovo prodotto che l'utente sta per aggiungere alla sua submission list
  // sia una carta singola appartenente a un brand al momento non gradabile su sleeve
  isCardNotGradableOnSleeve(categoryId) {
    return this.props.notGradableBrandsOnSleeve.includes(Number(this.newSupplementaryItem.brand_id)) && categoryId == this.props.singleCardsId;
  }


  // Funzione che si occupa di creare e aggiungere alla submission list un nuovo supplementary item
  createNewSupplementaryItem() {
    if (this.isValidProduct()) {
      if (!this.props.submissionList.grader_company?.reached_max_items_number) {
        enableHtmlElement(this.shadowRoot, 'add_new_product_btn', false);
        const url = `/submission_lists/${this.props.submission_list_id}`;

        fetch(url + ".json", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({supplementary_item: this.newSupplementaryItem}),
        })
          .then((response) => {
            if (!response.ok)
              throw Error("An error occour during saving data on the database");
            else
              return response.json();
          })
          .then((submissionList) => {
            this.newSupplementaryItem['description'] = '';
            setHtmlElementValue(this.shadowRoot, 'description', '');
            this.eventBus.publish('updated-submission-list-state', submissionList);
            this.eventBus.publish('created-new-supplementary-item', submissionList.last_supplementary_item);
            this.eventBus.publish('render-new-success-flash-message', I18n.t('js.editSubmissionListPage.webComponent.draft.productAddedToSubmission'));
            enableHtmlElement(this.shadowRoot, 'add_new_product_btn', true);
          })
          .catch((error) => {
            enableHtmlElement(this.shadowRoot, 'add_new_product_btn', true);
            console.error("ERROR:", error);
            this.eventBus.publish('render-modal', {error: true});
          });
      } else
        SubmissionListBlockModalComponent.getInstance(this.shadowRoot, this.props.submissionList);
    }
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    this.props.submissionList = { ...submissionList};
    this.handleMiddlemanEstimatedPriceRendering();
  }


  // Funzione che chiede al server, mediante richiesta http, l'anteprima del prezzo di gradazione del nuovo articolo che
  // l'utente sta aggiungendo alla submission list
  getSupplementaryItemEstimatedPrice() {
    this.pricingParams = {
      category_id: this.newSupplementaryItem.category_id,
      encasing: this.newSupplementaryItem.encasing,
    }

    if (this.pricingParams.category_id && this.pricingParams.encasing) {
      if (isPresent(this.prices[this.pricingParams.category_id]) &&
          isPresent(this.prices[this.pricingParams.category_id][this.pricingParams.encasing])) {
        const price = this.prices[this.pricingParams.category_id][this.pricingParams.encasing];
        setHtmlElementContent(this.shadowRoot, 'estimated_price', parseAmount(price[3]));
        setHtmlElementContent(this.shadowRoot, 'customer_estimated_price', parseAmount(price[1]));
      } else {
        const url = `/supplementary_items/pricing/get.json?submission_list_id=${this.props.submissionList.id}&category_id=${this.pricingParams.category_id}&encasing=${this.pricingParams.encasing}`;

        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok)
              throw Error("An error occour during saving data on the database");
            else
              return response.json();
          })
          .then((pricing) => {
            if (!isPresent(this.prices[this.pricingParams.category_id]))
              this.prices[this.pricingParams.category_id] = {}
            this.prices[this.pricingParams.category_id][this.pricingParams.encasing] = pricing;
            setHtmlElementContent(this.shadowRoot, 'estimated_price', `${parseAmount(pricing[3])}`)
            setHtmlElementContent(this.shadowRoot, 'customer_estimated_price', `${parseAmount(pricing[1])}`)
          })
          .catch((error) => {
            console.error("ERROR:", error);
          });
      }
    } else {
      setHtmlElementContent(this.shadowRoot, 'estimated_price', '0');
      setHtmlElementContent(this.shadowRoot, 'customer_estimated_price', '0');
    }
  }


  // Funzione che gestisce l'eventuale rendering sul form di inserimento di un nuovo prodotto
  // all'interno della submission list dell'anteprima del prezzo dedicato all'aggregatore
  handleMiddlemanEstimatedPriceRendering() {
    if (!this.props.submissionList.is_middleman_for_company || !this.showMiddlemanPrices) {
      addHtmlElementClass(this.shadowRoot, 'estimated_price_container', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'customer_estimated_price_msg', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'estimated_price_msg', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'vat_included', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'vat_included', 'd-none');
    }
    else {
      removeHtmlElementClass(this.shadowRoot, 'estimated_price_container', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'customer_estimated_price_msg', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'estimated_price_msg', 'd-none')
      removeHtmlElementClass(this.shadowRoot, 'vat_included', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'vat_included', 'd-none');
    }
  }


  // Funzione che renderizza a video, mediante un'animazione di tipo ease-in, il subbanner che segnala testualmente
  // all'utente i dati mancanti nel form di immissione di un nuovo articolo in submission list
  handleRenderingSubbanner(id, show, fun) {
    if (show) {
      addHtmlElementClass(this.shadowRoot, id, 'slide-down');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-up');
      addHtmlElementClass(this.shadowRoot, id, 'border-bottom-solid');
      if (window.innerWidth <= 767) {
        addHtmlElementClass(this.shadowRoot, id, 'pt-4');
        removeHtmlElementClass(this.shadowRoot, 'form-container', 'shadow');
      } else {
        addHtmlElementClass(this.shadowRoot, id, 'bg-white-imp');
      }
    } else {
      addHtmlElementClass(this.shadowRoot, id, 'slide-up');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-down');
      removeHtmlElementClass(this.shadowRoot, id, 'border-bottom-solid');

      setTimeout(() => {
        removeHtmlElementClass(this.shadowRoot, id, 'pt-4');
        addHtmlElementClass(this.shadowRoot, 'form-container', 'shadow');
      }, EASE_IN_TRANSITION_TIME)
    }

    if (fun)
      setTimeout(() => fun(), 2 * (EASE_IN_TRANSITION_TIME / 3))
  }




  render() {
    const html = `
      <!-- FORM DI IMMISSIONE DI UN NUOVO ARTICOLO IN SUBMISSION LIST -->
      <div class="border-solid br-20px shadow w-100 mx-0 z-index-125 overflow-auto" id="form-container">
        <div class="row w-100 border-top-radius-20px bg-aig-gradient m-0 py-1">
          <div class="col-12 col-md-6 text-left">
            <p
              class="submission-list-product-description-input submission-list-small-input mb-0 pb-0 w-100"
            >
              ${I18n.t('js.editSubmissionListPage.webComponent.draft.itemFormTitle')}
            </p>
          </div>
          
          <div class="col-12 col-md-6 d-flex d-sm-block d-md-flex justify-content-end text-right pt-3 pl-0">
            <div class="mr-3 mr-sm-0 mr-md-3">
              <h6 class="text-white mt--3px-imp">
                <small id="customer_estimated_price_msg">
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.amountForCustomer')}:
                </small>
                <b>
                  <span id="customer_estimated_price">0</span>${CURRENCY_EURO}
                </b>
                <small id="vat_included">
                  (${I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncluded')})
                </small>
              </h6>
              
              <h6 class="text-white mt--3px-imp" id="estimated_price_container">
                <small id="estimated_price_msg">
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.amount')}:
                </small>
                <b>
                  <span id="estimated_price">0</span>${CURRENCY_EURO}
                </b>
                <small id="vat_excluded">
                  (${I18n.t('js.editSubmissionListPage.webComponent.draft.vatExcluded')})
                </small>
              </h6>
            </div>
          </div>
        </div>
          
        <div class="row w-100 m-0">
          <div class="col-12 text-left border-bottom-solid py-1 pr-1" id="description_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.productDescription').toUpperCase()}
                </small>
                <question-tooltip-component
                  props='${obj2string({
                    title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_description_p1"),
                    body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_description_p2"),
                      I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_description_p3")],
                    id: "description_container"
                  })}'
                ></question-tooltip-component>
              </div>
  
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="description_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <div>
              <input
                type="text"
                class="form-control supplementary-item-form-input border-left-radius-3px-imp w-100"
                name="description"
                id="description"
                placeholder="${I18n.t('js.editSubmissionListPage.webComponent.draft.productDescriptionPlaceholder')}"
                autocomplete="off"
              />
            </div>
          </div>
          
          <div class="col-6 col-lg-3 d-flex flex-directions-column justify-content-between text-left border-right-solid border-bottom-solid py-1 pr-1" id="brand_id_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">${I18n.t("js.advancedSearch.filterComponent.brand").toUpperCase()}</small>
                <question-tooltip-component
                  props='${obj2string({
                    title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_brand_p1"),
                    body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_brand_p2"),
                      I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_brand_p3")],
                    id: "brand_id_container"
                  })}'
                ></question-tooltip-component>
              </div>
              
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="brand_id_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_1" 
              id="brand_id"
            >
              <option value="" id="no_brand_id">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
              </option>
              ${this.props.brands.map((brand) =>
                `<option value=${brand[1]} id="brand_id_${brand[1]}">
                   ${brand[0]}
                </option>`
              ).join('')}
            </select>
          </div>
          
          <div class="col-6 col-lg-3 d-flex flex-directions-column justify-content-between text-left border-bottom-solid py-1 pr-1" id="category_id_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">${I18n.t("js.advancedSearch.productProperty.productType").toUpperCase()}</small>
                <question-tooltip-component
                  props='${obj2string({
                    title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_type_p1"),
                    body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_type_p2"),
                           I18n.t("js.editSubmissionListPage.webComponent.questiontip.item_type_p3")],
                    id: 'category_id_container'
                  })}'
                ></question-tooltip-component>
              </div>
  
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="category_id_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_2" 
              id="category_id"
            >
            </select>
          </div>
          
          <!--
          <div class="col-6 col-lg-3 text-left border-left-lg-solid border-right-solid border-bottom-solid py-1 pr-1" id="estimated_value_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">${I18n.t("js.editSubmissionListPage.webComponent.draft.estimatedValue").toUpperCase()}</small>
                <question-tooltip-component
                  props='${obj2string({
                    body: ["lorem ispum", "dolor sit amet", "consectetur adipiscing elit."],
                    id: 'estimated_value_container'
                  })}'
                ></question-tooltip-component>
              </div>
    
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="estimated_value_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text supplementary-item-form-input mr-1 pt-1px-imp">${CURRENCY_EURO}</div>
              </div>
              <input
                type="number"
                min="0.1"
                class="form-control supplementary-item-form-input border-left-radius-3px-imp"
                name="input_field_3" 
                id="estimated_value"
              />
            </div>
          </div>
          -->
          
          <div class="col-6 col-lg-3 d-flex flex-directions-column justify-content-between text-left border-left-lg-solid border-right-solid border-bottom-solid py-1 pr-1" id="encasing_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">${I18n.t("js.editSubmissionListPage.webComponent.draft.encasing").toUpperCase()}</small>
                <question-tooltip-component
                    props='${obj2string({
                    title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.encasing_p1"),
                    body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.encasing_p2"),
                           I18n.t("js.editSubmissionListPage.webComponent.questiontip.encasing_p3")],
                    id: 'encasing_container'
                  })}'
                ></question-tooltip-component>
              </div>
    
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="encasing_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_3" 
              id="encasing"
            >
              <option value="" id="no_encasing">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
              </option>
              <option value="case" id="encasing_case">
                ${titleize(parseEncasing("case", "singles").toLowerCase())}
              </option>
              <option value="sleeve" id="encasing_sleeve">
                ${titleize(parseEncasing("sleeve", "singles").toLowerCase())}
              </option>
            </select>
          </div>
          
          <div class="col-6 col-lg-3 d-flex flex-directions-column justify-content-between text-left border-bottom-solid py-1 pr-1" id="requested_service_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">${I18n.t("js.editSubmissionListPage.webComponent.draft.serviceRequested").toUpperCase()}</small>
                <question-tooltip-component
                  props='${obj2string({
                    title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.service_p1"),
                    body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.service_p2"),
                           I18n.t("js.editSubmissionListPage.webComponent.questiontip.service_p3")],
                    id: "requested_service_container"
                  })}'
                ></question-tooltip-component>
              </div>
    
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="requested_service_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_4" 
              id="requested_service"
            >
              <option value="" id="no_requested_service">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
              </option>
              ${['grading', 'authentication', 'authentication_with_subgrades'].map((service) =>
                `<option value=${service} id="requested_service_${service}">
                   ${I18n.t(`js.editSubmissionListPage.webComponent.draft.service.${service}`)}
                </option>`
              ).join('')}
            </select>
          </div>
          
          <div class="col-6 col-lg-3 d-flex flex-directions-column justify-content-between text-left border-right-solid py-1 pr-1" id="label_type_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">${I18n.t("js.editSubmissionListPage.webComponent.draft.labelType").toUpperCase()}</small>
                <question-tooltip-component
                  props='${obj2string({
                    title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_type_p1"),
                    body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_type_p2"),
                      I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_type_p3"),
                      I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_type_p4")],
                    id: "label_type_container",
                    displayLabelTypes: true
                  })}'
                ></question-tooltip-component>
              </div>
    
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="label_type_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_5" 
              id="label_type"
            >
              <!--
              <option value="" id="no_label_type">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
              </option>
              -->
              ${['radiant', 'legacy'].map((type) =>
                `<option value=${type} id="label_type_${type}">
                   ${I18n.t(`js.editSubmissionListPage.webComponent.draft.labelTypeOption.${type}`)}
                </option>`
              ).join('')}
            </select>
          </div>
          
          <div class="col-6 col-lg-3 d-flex flex-directions-column justify-content-between text-left py-1 pr-1" id="label_language_container">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex justify-content-start m-0 p-0">
                <small class="color-gray mr-2 font-size-14px">${I18n.t("js.editSubmissionListPage.webComponent.draft.labelLanguage").toUpperCase()}</small>
                <question-tooltip-component
                  props='${obj2string({
                    title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_language_p1"),
                    body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_language_p2"),
                      I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_language_p3")],
                    id: "label_language_container"
                  })}'
                ></question-tooltip-component>
              </div>
    
              <div class="d-flex justify-content-end m-0 p-0">
                <img src="/images/icons/asterisck.svg" id="label_language_alert"
                  alt="" width="16" height="16" class="d-none mr-1"
                >
              </div>
            </div>
            
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_6" 
              id="label_language"
            >
              <option value="" id="no_label_language">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
              </option>
              ${['en', 'native'].map((language) =>
                `<option value=${language} id="label_language_${language}">
                   ${I18n.t(`js.editSubmissionListPage.webComponent.draft.labelLanguageOption.${language}`)}
                </option>`
              ).join('')}
            </select>
          </div>
          
          <div class="col-6 col-lg-3 d-flex flex-directions-column justify-content-between text-left border-left-lg-solid border-right-solid border-top-solid border-top-lg-none py-1 pr-1" id="grading_lower_limit_container">
            <div class="d-flex justify-content-start">
              <small class="color-gray mr-2 font-size-14px">${I18n.t("js.editSubmissionListPage.webComponent.draft.authenticateIf").toUpperCase()} (${I18n.t("js.editSubmissionListPage.webComponent.draft.optional")})</small>
              <question-tooltip-component
                props='${obj2string({
                  title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.authenticate_if_p1"),
                  body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.authenticate_if_p2"),
                    I18n.t("js.editSubmissionListPage.webComponent.questiontip.authenticate_if_p3")],
                  id: "grading_lower_limit_container"
                })}'
              ></question-tooltip-component>
            </div>
            
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_7" 
              id="grading_lower_limit"
            >
              <option value="" id="no_grading_lower_limit">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
              </option>
              ${numeric_values.map((grade) =>
                `<option value=${grade} id="grading_lower_limit_${grade}">
                   ${I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThen')} ${grade}
                </option>`
              ).join('')}
            </select>
            <p id="grading_lower_limit_not_applicable" class="mb-0 mt-10px">
              ${I18n.t('js.editSubmissionListPage.webComponent.draft.na')}
            </p>
          </div>
          
          <div class="col-6 col-lg-3 text-left border-top-solid border-top-lg-none py-1 pr-1" id="case_lower_limit_container">
            <div class="d-flex justify-content-start">
              <small class="color-gray mr-2 font-size-14px">${I18n.t("js.editSubmissionListPage.webComponent.draft.sleeveIf").toUpperCase()} (${I18n.t("js.editSubmissionListPage.webComponent.draft.optional")})</small>
              <question-tooltip-component
                props='${obj2string({
                  title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.sleeve_if_p1"),
                  body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.sleeve_if_p2"),
                    I18n.t("js.editSubmissionListPage.webComponent.questiontip.sleeve_if_p3")],
                  id: "case_lower_limit_container"
                })}'
              ></question-tooltip-component>
            </div>
              
            <select 
              class="form-control supplementary-item-form-input supplementary-item-form-select"
              name="input_field_8" 
              id="case_lower_limit"
            >
              <option value="" id="no_case_lower_limit" class="mt-2">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
              </option>
              ${numeric_values.map((grade) =>
                `<option value=${grade} id="case_lower_limit_${grade}">
                   ${I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThen')} ${grade}
                </option>`
              ).join('')}
            </select>
            <p id="case_lower_limit_not_applicable" class="mb-0 mt-10px">
              ${I18n.t('js.editSubmissionListPage.webComponent.draft.na')}
            </p>
          </div>
        </div>
        
        <div class="row d-flex align-items-center pt-2 border-top-solid mx-0">
          <div class="col-2 d-block text-right px-0 bg-white-imp"></div>
          
          <div class="col-8 d-block text-center px-0 pb-2 bg-white-imp">
            <button
              id="add_new_product_btn"
              class="btn-standard bg-aig-gradient color-white br-50px border-none-imp h-35px text-center px-4 px-sm-5"
              type="button"
            >
              ${I18n.t('js.editSubmissionListPage.webComponent.draft.addProduct').toUpperCase()}
            </button>
          </div>
          
          <div class="col-2 d-block text-right pl-0 pr-2 bg-white-imp">
            <img src="/images/icons/refresh.svg" class="cursor-pointer" id="refresh"
                alt="" width="30" height="30" 
              >
          </div>
        </div>
      </div>
        
        
        
        
        
      <!-- SEZIONE MESSAGGI DI ERRORE PER L'UTENTE -->
      <div class="d-flex justify-content-center align-items-center m-0 p-0 w-100">
        <div id="validations_container"
         class="row slide-animation-container mx-0 w-100 w-md-65 mt--15px mt-md-0 border-bottom-radius-20px border-left-solid border-right-solid d-block justify-content-center shadow-on-left-bottom-right slide-animation-container">
          <div class="text-aiBlue m-3 font-size-1rem">
            ${I18n.t("js.editSubmissionListPage.webComponent.validation.missing_attributes")}
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, submissionListsStyles]);

    this.handleChangeGraderCompany(this.props.submissionList.grader_company);
    this.handleMiddlemanEstimatedPriceRendering();
  }
}

window.customElements.define("supplementary-item-form-component", SupplementaryItemFormComponent);
